export const sotType = {
  SOT: 'sot',
  FLOOR: 'floorSot',
  CEILING: 'ceilingSot',
} as const;

type SotType = typeof sotType;

export type SotTypes = SotType[keyof SotType];

export type SotValues<T> = { [key in SotTypes]: T };
